var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoshDubbing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 42,
    viewBox: "0 0 255 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 42,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_51_1579",
    transform: "scale(0.00392157 0.0238095)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_51_1579",
    width: 255,
    height: 42,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP8AAAAqCAYAAAB8+41WAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAJDSURBVHhe7dw9btRAGMbxx0jRIkKBqDjAGqEV4gDrE2wuQWeX64aOCtHReMtsnYoCISTsE9hcIIpEbGooqfiozNhrL44UIKBN2M37/0kjj2fiSfVkXo8Ue7UjAObc6K4AjCH8gFGEHzBq69/5qy9fdfTxU3f37+6NRnqwf0uPbu/r7t5eNwrYxYEfYBRlP2AU4QeMIvyAUYQfMIrwA0YRfsAoO+HPInleoEXV3W/KZa0LXDJ2fsAoE+HPIk/ewdL1CsW+63ueguFW3e7eq/G2BQud2cirhYLBfJSthv+4LrDFTIR/dlirTkPXmyopXb+ulc/H7Vy1CFyApdSNNeN1XSpRLH/9ByBT5MdyD67nJ88jN/r7dYFtZ7zsz/QiLhSmh5p1I9JY86cu0MVLvT13E3fz+fDngd1kO/zVqY7dZXnws6RvW1vK92Z6kkxVxL6b42AP1wcHfk6Y9iX/sOXqK/jxPG/H0rB/t1+V/cAusx3+8X09dJfj04tt5+07fpm4N/ylXpN+7Dg74fcnLrSFTsruvtWX9I/PlvPN6X9/4Nf0++P9RnniVplq4nf3564L7ABXzpqRhmq+XdA2V+qvlcl0Pd62aVKX3Vxj+FzThs82frUusM34mAdgFAd+gFGEHzCK8ANGEX7AKMIPGEX4AaMIP2AU4QeMIvyAUYQfMIrwA0YRfsAowg8YRfgBowj/Bj3L33W9q/Om+qBX7/mSCP4e/8+/QZ+/fdedm6Pu7mr8j9+J64HwA0ZR9gNGEX7AJOkHBJSGJEczTTUAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoshDubbing);
export default __webpack_public_path__ + "static/media/PoshDubbing.1be18a156d384d7ddf1c7424b430c1cd.svg";
export { ForwardRef as ReactComponent };